var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 'Model'),expression:"activeTab == 'Model'"}],key:'a',attrs:{"id":"Model"}},[_c('filtr',{key:'c',staticClass:"p-3",attrs:{"attr":'kolekcja',"folder":'kolekcje',"scrollerdata":_vm.kolekcjafilter,"col":'5'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }